import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { commissionSlabQueries } from '@/services/slabs/slabs.queries';
import { useParams, useSearch } from '@tanstack/react-router';

export const useSlabs = () => {
  const search = useSearch({ from: '/(app)/configuration-management/commissions/$categoryId/' });
  const { page, fetch, adminCommissionTypeId, sort } = search;
  const { categoryId } = useParams({ from: '/(app)/configuration-management/commissions/$categoryId' });

  const { data, isLoading } = useQuery({
    ...commissionSlabQueries.list({
      categoryId,
      adminCommissionTypeId: adminCommissionTypeId,
      row: page ?? 1,
      fetch: fetch ?? 10,
    }),

    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
    enabled: !!adminCommissionTypeId,
  });
  return { slab: data?.data || [], isLoading, meta: data?.meta.pagination ?? defaultMeta };
};
